import { useNavigate } from "react-router-dom";
import "./AssignmentUniversity.css";
import { useEffect, useState } from "react";
import axios from "axios";

const AssignmentUniversity = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [university, setUniversity] = useState("");

  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [course, setCourse] = useState("");

  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [semester, setSemester] = useState();

  const [universitySubjects, setUniversitySubjects] = useState([]);
  const [universitySubjectId, setUniversitySubjectsId] = useState("");
  const [subject, setSubject] = useState("");

  const [title, setTitle] = useState("");
  const [language, setLanguage] = useState("");
  const [file, setfile] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const navigate = useNavigate();

  console.log(university, course);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (courseId) {
      axios
        .get(
          `${API_BASE_URL}/college-subjects?courseId=${courseId}&semesterId=${semesterId}`
        )
        .then((response) => {
          const UniversitySubjects = response.data?.data || [];
          setUniversitySubjects(UniversitySubjects);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [courseId, semesterId]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create FormData object to handle file upload
    const formData = new FormData();
    formData.append("university", university);
    formData.append("course", course);
    formData.append("semester", semester);
    formData.append("subject", subject);
    formData.append("title", title);
    formData.append("univercityassignmentpdf", file);
    formData.append("language", language);
    formData.append("subjectId", universitySubjectId);


    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/assignment`
        : `${API_BASE_URL}/admin/assignment`;


    // Make POST request
    axios
      .post(
        // `${API_BASE_URL}/admin/assignment`, 
        endpoint,
        formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log("Assignment submitted successfully:", response.data);
        alert("Assignment submitted successfully");
        navigate("/student-assignment/all-university");
      })
      .catch((error) => {
        console.error("Error submitting assignment:", error);
      });
  };

  return (
    <div>
      <div id="assignment-university-main-container">
        <div className="ass-university-heading-or-btns">
          <h4>University Assignment</h4>
          <div className="ass-university-nav-btns">
            <button>University Assignment</button>
            <button
              onClick={() => navigate("/student-assignment/all-university")}
            >
              University All Assignments
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="note-detail-form">
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Select University</label>
            <select
              className="new-chapter-dropdown"
              value={universityId}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedText = e.target.options[selectedIndex].text;
                setUniversityId(e.target.value);
                setUniversity(selectedText);
              }}
              required
            >
              <option value="">-Select University-</option>
              {universities.map((universitie, idx) => (
                <option key={idx} value={universitie._id}>
                  {universitie.universityName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Course Name</label>
            <select
              className="new-chapter-dropdown"
              value={courseId}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedText = e.target.options[selectedIndex].text;
                setCourseId(e.target.value);
                setCourse(selectedText);
              }}
              required
            >
              <option value="">-Select Course-</option>
              {courses.map((course, idx) => (
                <option key={idx} value={course._id}>
                  {course.courseName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Semester</label>
            <select
              className="new-chapter-dropdown"
              value={semesterId}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedText = e.target.options[selectedIndex].text;
                setSemesterId(e.target.value);
                setSemester(selectedText);
              }}
              required
            >
              <option value="">-Select Semester-</option>
              {semesters.map((semester, idx) => (
                <option key={idx} value={semester._id}>
                  {semester.semesterName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Subject</label>
            <select
              className="new-chapter-dropdown"
              value={universitySubjectId}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedText = e.target.options[selectedIndex].text;
                setUniversitySubjectsId(e.target.value);
                setSubject(selectedText);
              }}
              required
            >
              <option value="">-Select Subject-</option>
              {universitySubjects.map((universitySubject, idx) => (
                <option key={idx} value={universitySubject._id}>
                  {universitySubject.subjectName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Language</label>
            <select
              className="new-chapter-dropdown"
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
              }}
              required
            >
              <option value="">-Select Subject-</option>
              <option value="english">English</option>
              <option value="hindi">Hindi</option>
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Title</label>
            <input
              type="text"
              placeholder="Enter Title"
              className="new-chapter-dropdown"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              required
            />
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">File</label>
            <input
              type="file"
              className="new-chapter-dropdown"
              onChange={(e) => setfile(e.target.files[0])} // Update state with the selected file
              required
            />
          </div>

          <div className="form1-btns">
            <button className="btn-save">Add Assignment</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssignmentUniversity;
